import Vue from "vue";
import VueRouter from "vue-router";
import axios from "axios";
import App from "./App.vue";
import routes from "./config/routes";
import store from "./store/";
import { routerMode } from "./config/env";
import MetaInfo from "vue-meta-info";
import Mint, {
  Loadmore,
  Navbar,
  TabItem,
  Lazyload,
  Actionsheet
} from "mint-ui";
import '../static/iconfont/iconfont.css'  //引入字体图标
import { title } from "./components/directives/directive";
import mUtils from "./config/mUtils";
import openApp from "./utils/openApp";
import getUa from "./utils/getUa";
import "lib-flexible";
import rule_math from "./tools/common";
import VueWechatTitle from "./components/vue-wechat-title";
// import { post, get, patch, put } from "./utils/https-bak"; //上线后把这个注释
import { post, get, patch, put } from "./utils/https"; //上线后把这个恢复
import { Toast } from "vant";
// vue2 轮播

import VConsole from "vconsole";

/* 全局头尾部 */
import header from "./components/common/header.vue";
import footer from "./components/common/footer.vue";
import calendar from "./components/calendar.vue";
import filters from "./utils/filters";
if (window.location.host === "test-m.xiaozhu.com") {
  const vConsole = new VConsole();
}
Vue.use(Toast);
// import VueTouch from 'vue-touch'
// import FastClick from 'fastclick'
// import $ from 'jquery'
// import Es6Promise from 'es6-promise'
// Vue.use(VueTouch, {name: 'v-touch'})
// Vue.component(Loadmore.name, Loadmore);
// Vue.use(Rate);
Vue.prototype.$getUa = getUa;
Vue.use(VueRouter);
Vue.use(Mint);
Vue.use(MetaInfo);
Vue.component(Navbar.name, Navbar);
Vue.component(TabItem.name, TabItem);
Vue.component(Actionsheet.name, Actionsheet);
Vue.use(Lazyload);
Vue.use(VueWechatTitle);
// 解决Vue-Router升级导致的Uncaught(in promise) navigation guard问题
const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};
// 听云监控
function formatComponentName(vm) {
  if (vm.$root === vm) return "root";
  const name = vm._isVue
    ? (vm.$options && vm.$options.name) ||
      (vm.$options && vm.$options._componentTag)
    : vm.name;
  return (
    (name ? "component <" + name + ">" : "anonymous component") +
    (vm._isVue && vm.$options && vm.$options.__file
      ? " at " + (vm.$options && vm.$options.__file)
      : "")
  );
}
Vue.config.errorHandler = function(err, vm, info) {
  if (vm) {
    const componentName = formatComponentName(vm);
    const propsData = vm.$options && vm.$options.propsData;
  }
};

Vue.prototype.$post = post;
Vue.prototype.$get = get;
Vue.prototype.$patch = patch;
Vue.prototype.$put = put;
// 使用配置文件规则
VueRouter.prototype.go = function() {
  this.isBack = true;
  window.history.go(-1);
};
Vue.prototype.getCookie = function(name) {
  let arr;
  const reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)");
  if ((arr = document.cookie.match(reg))) return unescape(arr[2]);
  else return null;
};
Vue.config.productionTip = false;
// 使用配置文件规则
const isHans = typeof history.pushState === "function";
const mode = isHans ? "hash" : "history";
const router = new VueRouter({
  mode: "hash",
  routes
});
Vue.component("my-head", header);
Vue.component("my-foot", footer);
Vue.component("my-calendar", calendar);

// 注入全局过滤器
Object.entries(filters).forEach(([key, item]) => {
  Vue.filter(key, item);
});
// 给app暂时用，用于处理app智齿上线ios不兼容url中带有回车编码，等app老版本强制更新后可删除
if (window.location.href.indexOf("/toApp/zhiChiGuideUpgrade") > -1) {
  window.location.href = "/#/toApp/zhiChiGuideUpgrade";
}
router.beforeEach((to, from, next) => {
  const cookieValue = !Vue.prototype.getCookie("wttXMuWwbC");
  if (!cookieValue) {
    next();
  } else {
    if (
      !(to.name === "detail" || to.name === "imMarker" || to.name === "result")
    ) {
      next();
    } else {
      const _query = JSON.stringify(to.query);
      next({
        path: "/cookie",
        query: {
          name: to.name,
          redirect: _query
        }
      });
    }
  }
  if (
    to.path === "/" &&
    sessionStorage.getItem("accessToken") &&
    from.path !== "/Table"
  ) {
    sessionStorage.removeItem("accessToken");
    next();
  } else if (to.meta.requiresAuth && !sessionStorage.getItem("accessToken")) {
    next({
      path: "/",
      query: {
        redirect: to.fullPath
      }
    });
  } else if (from.path === "/Table" && to.path === "/") {
    next({
      path: "/Table"
    });
  } else {
    next();
  }
});
new Vue({
  router,
  store,
  el: "#app",
  render: h => h(App),
  mounted() {
    document.dispatchEvent(new Event("render-event"));
  },
  created() {
    // 设置分享问题
    this.setShare();
  }
});

router.afterEach((to, from, next) => {
  if (from.name !== "result") {
    window.scrollTo(0, 0);
  }
});



// WEBPACK FOOTER //
// ./src/main.js